// The default values of a new sms template per library type, the
// bodies match the dutch example messages of the module

// The shape of the sms template defaults
interface SmsTemplateDefaults {
    body: string;
    send_time: string | null;
}

// Set the defaults per message type
export const smsTemplateLibraryDefaults: Record<string, SmsTemplateDefaults> = {
    day_before_reminder: {
        body: '{datum} tussen {tijdvak} komen we bij u langs. Niet gelegen? Bel ons gerust.',
        send_time: '15:00',
    },
    same_day_morning: {
        body: 'Vandaag tussen {tijdvak} staan we bij u voor de deur.',
        send_time: '07:30',
    },
    appointment_booked: {
        body: 'We hebben een afspraak voor u ingepland op {datum} tussen {tijdvak}.',
        send_time: null,
    },
    on_the_way: {
        body: '{monteur} is onderweg naar u en is er over ongeveer {reistijd}.',
        send_time: null,
    },
    delay: {
        body: 'We lopen helaas uit. We verwachten rond {nieuwe_tijd} bij u te zijn.',
        send_time: null,
    },
    no_answer: {
        body: 'We stonden zojuist bij u voor de deur maar troffen niemand aan. Bel ons voor een nieuwe afspraak.',
        send_time: null,
    },
};

// The automatic message types that use a send time
export const AUTOMATIC_SMS_MESSAGE_TYPES = ['day_before_reminder', 'same_day_morning'];
